import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useUserAPI } from '../../contexts/UserAPIContext';
import PageLoader from '../../components/PageLoader';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import TimeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from "@fullcalendar/interaction"
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import moment from "moment";
import { useNotification } from '../../contexts/NotificationContext';
import { getImageUrl } from '../../firebase/storageService'; // função criada acima
import CustomAutoComplete from "../../components/CustomAutoComplete";
import DateDisplay from "../../components/DateDisplay";
import { authFetch } from "../../utils/authFetch";
import { useEscalaCache } from "../../hooks/useEscalaCache";

const PerfilTerapeuta = () => {

  const location = useLocation();

  useEffect(() => {
    if (location.state?.abrirEscala) {      
      handleTabClick();
    }
  }, [location.state]);

  const { userAPIData } = useUserAPI();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  const [anoRef, setAnoRef] = useState([new Date().getFullYear()]);
  const [mesRef, setMesRef] = useState(() => {
    const mesAtual = new Date().getMonth() + 1; // getMonth retorna de 0 a 11
    return String(mesAtual).padStart(2, '0'); // formata para '01', '02' etc.
  });
  const meses = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));

  const { id } = useParams(); // Pega o ID da rota /Terapeutas/PerfilTerapeuta/:id
  const [terapeuta, setTerapeuta] = useState(null);
  
  // Hook para gerenciar cache da escala
  const escalaCache = useEscalaCache(id);
  const [pacientesGer, setPacientesGer] = useState([]);
  const [funcoes, setFuncoes] = useState([]);
  const [funcoesTerap, setFuncoesTerap] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [preview, setPreview] = useState(null);
  const [pacientesLoaded, setPacientesLoaded] = useState(false);
  const [sessionControlLoaded, setSessionControlLoaded] = useState(false);
  const [funcoesLoaded, setFuncoesLoaded] = useState(false);

  const [pacienteFoiSelecionadoExternamente, setPacienteFoiSelecionadoExternamente] = useState(false);
  const [terapeutaFoiSelecionadoExternamente, setTerapeutaFoiSelecionadoExternamente] = useState(false);

  const niveisTerapeuta = {
    0: 'Gestora',
    1: 'Júnior',
    2: 'Estagiária',
    3: 'Sênior',
  };

  //Modais
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [isReadOnlyModal, setIsReadOnlyModal] = useState(false);

  //Variáveis da Página  
  const [reposicao, setReposicao] = useState(0);
  const [geraReposicao, setGeraReposicao] = useState(0);
  const [pacienteSearch, setPacienteSearch] = useState('');
  const [terapeutaSearch, setTerapeutaSearch] = useState('');
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  const [terapeutaSelecionado, setTerapeutaSelecionado] = useState(null);
  const [funcoesTerapeuta, setFuncoesTerapeuta] = useState([]);
  const [outrasTerapeutas, setOutrasTerapeutas] = useState([]);
  const [consideraValor, setConsideraValor] = useState(false);
  const [planosPaciente, setPlanosPaciente] = useState([]);
  const [titulo, setTitulo] = useState("");
  const [falta, setFalta] = useState(0);
  const [faturada, setFaturada] = useState(0);
  const [tipoAgendEdit, setTipoAgendEdit] = useState(0);

  const [allDay, setAllDay] = useState(false);

  const handleHoraInicioChange = (e) => {
    const novaHoraInicio = e.target.value;
    setHoraInicio(novaHoraInicio);

    if (horaFim <= novaHoraInicio) {
      const index = horarios.indexOf(novaHoraInicio);
      const proximaHora = horarios[index + 2] || "23:59";
      setHoraFim(proximaHora);
    }
  };

  const BotaoGerarUsuario = () => {
    navigate(`/Terapeutas/GerarUsuario/${terapeuta.id}`);
  };

  // Gera os horários que são utilizados nos modais dos eventos
  const gerarHorarios = () => {
    const horarios = [];
    for (let h = 0; h < 24; h++) {
      for (let m of [0, 30]) {
        const hora = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
        horarios.push(hora);
      }
    }
    return horarios;
  };
  const horarios = gerarHorarios();

  const handleAllDayChange = (e) => {
    const checked = e.target.checked;
    setAllDay(checked);

    if (checked) {
      setHoraInicio("00:00");
      setHoraFim("23:59");
    } else {
      const novaHoraInicio = arredondarHoraAtual();
      const novaHoraFim = horaFinalPadrao();
      setHoraInicio(novaHoraInicio);
      setHoraFim(novaHoraFim);
    }
  };

  //Arredonda Hora Atual para o Modal de Novo Evento abrir sempre com hora cheia, nunca hora quebrada
  const arredondarHoraAtual = () => {
    const agora = new Date();
    const hora = agora.getHours();
    return `${String(hora).padStart(2, '0')}:00`;
  };

  const horaAtual = arredondarHoraAtual();
  const horaFinalPadrao = () => {
    const hora = new Date().getHours() + 1;
    return `${String(Math.min(hora, 23)).padStart(2, '0')}:00`;
  };

  const [horaInicio, setHoraInicio] = useState(horaAtual);
  const [horaFim, setHoraFim] = useState(horaFinalPadrao());

  const [dataInicio, setDataInicio] = useState(moment().format("YYYY-MM-DD"));
  const [dataFim, setDataFim] = useState(moment().format("YYYY-MM-DD"));

  const handleDataInicioChange = (e) => {
    const novaDataInicio = e.target.value;
    setDataInicio(novaDataInicio);
  }

  const handleDataFimChange = (e) => {
    const novaDataFim = e.target.value;
    setDataFim(novaDataFim);
  }

  const formatarParaMoeda = (valor) => {
    let numero = valor.replace(/\D/g, "");
    numero = (parseInt(numero || "0", 10) / 100).toFixed(2);
    return numero
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const buscarTerapeutasExtrasEventoEdit = async (appointmentId) => {
    try {
      const response = await authFetch(`appointment/${appointmentId}`, {
      });

      if (!response.ok) throw new Error("Erro ao buscar agendamento");

      const data = await response.json();

      return data.therapists?.map((t) => ({
        therapistId: t.therapistId,
        therapistName: t.therapistName,
        jobPositionId: t.jobPositionName,
        jobPositionName: t.jobPositionName
      })) || [];

    } catch (error) {
      console.error("Erro ao buscar terapeutas extras:", error);
      return [];
    }
  };

  const [formEditEvent, setFormEditEvent] = useState({
    startDatetime: "", // Definir um valor inicial válido
    endDateTime: "",
    note: "",
    tipo: 1,
    title: "",
    patientId: "",
    planId: "",
    therapistId: "",
    jobPositionId: "",
    roomId: "",
    value: "",
  });

  //Tipos de Agendamento Para Selecionar no Combobox
  const tiposAgendamento = [
    { id: 0, nome: "Livre" },
    { id: 1, nome: "Sessão" },
    { id: 2, nome: "Avulso" }
  ];

  const [mesFechadoCtrl, setMesFechadoCtrl] = useState(false);

  const [formAddFuncao, setFormAddFuncao] = useState({
    therapistId: id,
    jobPositionId: "", // Valor inicial vazio
    salary: 0, // Verifique se paciente.id está disponível
  });

  const formatarValor = (valor) => {
    if (!valor) return '0,00';
    return Number(valor).toFixed(2).replace('.', ',');
  };

  // Preenche os campos do formulário conforme digitação
  const handleInputChangeFunc = (e) => {
    const { name, value } = e.target;

    let newValue = value;

    if (name === 'salary') {
      // Remove tudo que não for número
      newValue = newValue.replace(/\D/g, '');

      // Converte para número e depois para string com duas casas decimais
      const numberValue = (parseInt(newValue, 10) / 100).toFixed(2);

      // Troca o ponto decimal por vírgula
      newValue = numberValue.replace('.', ',');

      // Adiciona separador de milhares
      newValue = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    setFormAddFuncao(prev => ({
      ...prev,
      [name]: newValue,
    }));
  };

  // Define automaticamente o primeiro valor da função quando as funções são carregadas
  useEffect(() => {
    if (funcoes.length > 0 && !formAddFuncao.jobPositionId) {
      setFormAddFuncao(prev => ({
        ...prev,
        jobPositionId: funcoes[0].id
      }));
    }
  }, [funcoes, formAddFuncao.jobPositionId]);


  useEffect(() => {
    const fetchTerapeuta = async () => {
      try {
        const response = await authFetch(`therapist/${id}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Erro ao buscar terapeuta");
        }
        const data = await response.json();
        setTerapeuta(data);  // Guarda o objeto inteiro
        // Carrega imagem do Firebase
        const url = await getImageUrl('therapist', id);
        setPreview(url);
      } catch (err) {
        setError(err.message);
        showNotification("danger", "Erro ao buscar terapeuta");
      } finally {
        setLoading(false);
      }
    };

    fetchTerapeuta();
  }, [showNotification, id]);


  const [showConfirmDeleteTerapeuta, setShowConfirmDeleteTerapeuta] = useState(false);

  const handleDeleteTerapeuta = async () => {
    try {
      const response = await authFetch(`therapist/${terapeuta.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw new Error('Erro ao excluir terapeuta');

      showNotification('success', 'Terapeuta excluído com sucesso');
      navigate('/Terapeutas'); // redireciona para a lista de terapeutas
    } catch (err) {
      console.error(err);
      showNotification('danger', 'Erro ao excluir terapeuta');
    } finally {
      setShowConfirmDeleteTerapeuta(false);
    }
  };


  const dataAtual = () => {
    const date = new Date();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const calendarRef = useRef(null);
  const pendingFetches = useRef(new Map());

  const handleTabClick = () => {
    setTimeout(() => {
      if (calendarRef.current) {
        calendarRef.current.getApi().updateSize();
      }
    }, 50);
  };

  const [ViewAtual] = useState("timeGridWeek");
  const [DataAtual] = useState(dataAtual());

  const handleFuncoesClick = async () => {
    if (!funcoesLoaded) {
      try {
        // Buscar todas as funções disponíveis
        const responseFuncoes = await authFetch("job-position", {});
        if (!responseFuncoes.ok) {
          throw new Error("Erro ao buscar funções do terapeuta");
        }
        const dataFuncoes = await responseFuncoes.json();
        setFuncoes(dataFuncoes);

        // Buscar funções do terapeuta
        const responseFuncoesTerap = await authFetch(`therapist-job-position/therapist/${id}`, {});
        if (!responseFuncoesTerap.ok) {
          throw new Error("Erro ao buscar funções do terapeuta");
        }
        const dataFuncoesTerap = await responseFuncoesTerap.json();
        setFuncoesTerap(dataFuncoesTerap);

        setFuncoesLoaded(true);
      } catch (error) {
        console.error("Erro ao carregar funções:", error);
        showNotification("danger", "Erro ao carregar funções");
      }
    }
  };

  const [funcaoParaExcluir, setFuncaoParaExcluir] = useState(null);
  const [showModalExcluirFuncao, setShowModalExcluirFuncao] = useState(false);
  const [showFormFuncao, setShowFormFuncao] = useState(false)
  const AddFuncao = () => {
    setShowFormFuncao(true)
  };

  const CancelaAddFuncao = () => {
    setShowFormFuncao(false)
  };

  const [idadeFormatada, setIdadeFormatada] = useState("");
  const [tempoAutin, setTempoAutin] = useState("");

  useEffect(() => {
    if (terapeuta && terapeuta.birthdate) {
      const [year, month, day] = terapeuta.birthdate.split("-").map(Number);
      const birthDate = new Date(year, month - 1, day); // mês é 0-based
      const today = new Date();

      let years = today.getFullYear() - birthDate.getFullYear();
      let months = today.getMonth() - birthDate.getMonth();
      let days = today.getDate() - birthDate.getDate();

      if (months < 0 || (months === 0 && days < 0)) {
        years--;
        months += 11;
      } else if (days < 0) {
        months--;
      }

      const anos = years === 1 ? " Ano e " : " Anos e ";
      const meses = months === 1 ? " Mês" : " Meses";

      setIdadeFormatada(`${years}${anos}${months}${meses}`);
    }
  }, [terapeuta]);

  useEffect(() => {
    if (terapeuta && terapeuta.hiringDate) {
      const [year, month, day] = terapeuta.hiringDate.split("-").map(Number);
      const hiringDate = new Date(year, month - 1, day); // mês é 0-based
      const today = new Date();

      let years = today.getFullYear() - hiringDate.getFullYear();
      let months = today.getMonth() - hiringDate.getMonth();
      let days = today.getDate() - hiringDate.getDate();

      if (months < 0 || (months === 0 && days < 0)) {
        years--;
        months += 11;
      } else if (days < 0) {
        months--;
      }

      const anos = years === 1 ? " Ano e " : " Anos e ";
      const meses = months === 1 ? " Mês" : " Meses";

      setTempoAutin(`${years}${anos}${months}${meses}`);
    }
  }, [terapeuta]);

  const sorrisoAutin = () => {
    const dataInicio = new Date(terapeuta.hiringDate);
    const dataFim = new Date(dataAtual());

    const diferencaEmMs = dataFim - dataInicio; // Diferença em milissegundos
    const diferencaEmAnos = diferencaEmMs / (1000 * 60 * 60 * 24 * 365.25); // Considerando anos bissextos

    if (diferencaEmAnos >= 1) {
      return true;
    } else {
      return false;
    }
  }

  const setarMesFechado = async (e) => {
    e.preventDefault();

    const payload = {
      therapistId: Number(id),
      referenceMonth: Number(mesRef),
      referenceYear: Number(anoRef),
      qtSessions: Number(qtdTotalAtendimentos),
      qtExtraSessions: Number(ctrlatendimentos?.qtExtraSessions),
      qtChargedAbsences: Number(totalFaltasComDesconto),
      qtNonChargedAbsences: Number(totalFaltasSemDesconto),
      description: ctrlatendimentos?.description,
      sessionValue: terapeuta.sessionFee,
      sessionExtraValue: terapeuta.extraFee,
      monthlySalary: salarioMes,
      isMonthClosed: true,
      totalExtraValue: totalExtras,
      monthClosed: true,
      ...(ctrlatendimentos.id && { id: ctrlatendimentos.id }) // só adiciona se existir
    };

    const method = ctrlatendimentos.id ? "PUT" : "POST";

    try {
      const res = await authFetch('therapist-session-control', {
        method: method,
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Erro ao salvar Controle");

      setMesFechadoCtrl(true);
      fetchCtrlAtendimentos();
      showNotification("success", "Controle salvo com sucesso!");

    } catch (error) {
      console.error("Erro ao salvar Controle:", error);
      showNotification("danger", "Erro ao salvar Controle");
    }

  }

  const salvarMes = async (e) => {
    e.preventDefault();

    const payload = {
      therapistId: Number(id),
      referenceMonth: Number(mesRef),
      referenceYear: Number(anoRef),
      qtSessions: Number(qtdTotalAtendimentos),
      qtExtraSessions: Number(ctrlatendimentos?.qtExtraSessions),
      qtChargedAbsences: Number(totalFaltasComDesconto),
      qtNonChargedAbsences: Number(totalFaltasSemDesconto),
      description: ctrlatendimentos?.description,
      sessionValue: terapeuta.sessionFee,
      sessionExtraValue: terapeuta.extraFee,
      monthlySalary: salarioMes,
      isMonthClosed: false,
      totalExtraValue: totalExtras,
      monthClosed: false,
      ...(ctrlatendimentos.id && { id: ctrlatendimentos.id }) // só adiciona se existir
    };

    const method = ctrlatendimentos.id ? "PUT" : "POST";

    try {
      const res = await authFetch('therapist-session-control', {
        method: method,
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Erro ao salvar Controle");

      showNotification("success", "Controle salvo com sucesso!");

    } catch (error) {
      console.error("Erro ao salvar Controle:", error);
      showNotification("danger", "Erro ao salvar Controle");
    }
  }

  const reabrirMesFechado = async (e) => {
    e.preventDefault();

    const payload = {
      id: ctrlatendimentos.id,
      therapistId: ctrlatendimentos.therapistId,
      referenceMonth: ctrlatendimentos.referenceMonth,
      referenceYear: ctrlatendimentos.referenceYear,
      qtSessions: ctrlatendimentos.qtSessions,
      qtExtraSessions: ctrlatendimentos.qtExtraSessions,
      qtChargedAbsences: ctrlatendimentos.qtChargedAbsences,
      qtNonChargedAbsences: ctrlatendimentos.qtNonChargedAbsences,
      description: ctrlatendimentos.description,
      sessionValue: ctrlatendimentos.sessionValue,
      sessionExtraValue: ctrlatendimentos.sessionExtraValue,
      monthlySalary: ctrlatendimentos.monthlySalary,
      totalExtraValue: ctrlatendimentos.totalExtraValue,
      // monthClosed: false,
      isMonthClosed: false
    };

    try {
      const res = await authFetch('therapist-session-control', {
        method: "PUT",
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Erro ao salvar Controle");

      setMesFechadoCtrl(false);
      showNotification("success", "Controle reaberto com sucesso!");

    } catch (error) {
      console.error("Erro ao salvar Controle:", error);
      showNotification("danger", "Erro ao reabrir Controle");
    }
  }

  const [totalExtras, setTotalExtras] = useState(0);
  const [totalAtendimentos, setTotalAtendimentos] = useState(0);
  const [salarioMes, setSalarioMes] = useState(0);
  const [qtdTotalAtendimentos, setQtdeTotalAtendimentos] = useState(0);
  const [totalFaltasComDesconto, setTotalFaltasComDesconto] = useState(0);
  const [totalFaltasSemDesconto, setTotalFaltasSemDesconto] = useState(0);

  const handleCasosGerenciadosClick = async () => {
    if (!pacientesLoaded) {
      try {
        const response = await authFetch(`patient?therapistId=${id}`, {
        });

        if (!response.ok) {
          throw new Error("Erro ao buscar pacientes");
        }

        const data = await response.json();

        // Primeiro setamos os pacientes com imageUrl null e imageLoading true
        setPacientesGer(data.map(paciente => ({
          ...paciente,
          imageUrl: null,
          imageLoading: true
        })));
        setPacientesLoaded(true);

        // Depois carregamos as imagens de forma assíncrona
        data.forEach(async (paciente) => {
          try {
            const url = await getImageUrl('patient', paciente.id);
            setPacientesGer(prevPacientes =>
              prevPacientes.map(p =>
                p.id === paciente.id
                  ? { ...p, imageUrl: url, imageLoading: false }
                  : p
              )
            );
          } catch (error) {
            console.error(`Erro ao carregar imagem do paciente ${paciente.id}:`, error);
            setPacientesGer(prevPacientes =>
              prevPacientes.map(p =>
                p.id === paciente.id
                  ? { ...p, imageUrl: require('../../assets/img/perfilvazio.png'), imageLoading: false }
                  : p
              )
            );
          }
        });

      } catch (error) {
        console.error("Erro ao carregar casos gerenciados:", error);
        showNotification("danger", "Erro ao carregar casos gerenciados");
      }
    }
  };

  const [ctrlatendimentos, setCtrlAtendimentos] = useState("");

  const handleControleAtendimentosClick = async () => {
    if (!funcoesLoaded) {
      try {
        // Buscar todas as funções disponíveis
        const responseFuncoes = await authFetch("job-position", {});
        if (!responseFuncoes.ok) {
          throw new Error("Erro ao buscar funções do terapeuta");
        }
        const dataFuncoes = await responseFuncoes.json();
        setFuncoes(dataFuncoes);

        // Buscar funções do terapeuta
        const responseFuncoesTerap = await authFetch(`therapist-job-position/therapist/${id}`, {});
        if (!responseFuncoesTerap.ok) {
          throw new Error("Erro ao buscar funções do terapeuta");
        }
        const dataFuncoesTerap = await responseFuncoesTerap.json();
        setFuncoesTerap(dataFuncoesTerap);

        setFuncoesLoaded(true);
      } catch (error) {
        console.error("Erro ao carregar funções:", error);
        showNotification("danger", "Erro ao carregar funções");
      }
    }

    if (!sessionControlLoaded) {
      await fetchCtrlAtendimentos();
      setSessionControlLoaded(true);
    }
  };

  const handleMesRefChange = (e) => {
    setMesRef(e.target.value);
  };

  const handleAnoRefChange = (e) => {
    setAnoRef(e.target.value.replace(/\D/g, ''));
  };

  const lastRequestRef = useRef(0);

  const fetchCtrlAtendimentos = async () => {
    const requestId = Date.now();
    lastRequestRef.current = requestId;

    // Zera estados antes de iniciar o fetch
    setCtrlAtendimentos(null);
    setTotalExtras(0);
    setTotalAtendimentos(0);
    setSalarioMes(0);
    setTotalFaltasComDesconto(0);
    setTotalFaltasSemDesconto(0);
    setQtdeTotalAtendimentos(0);
    setMesFechadoCtrl(false);

    try {
      const response = await authFetch(
        `therapist-session-control/therapist/${id}/month/${mesRef}/year/${anoRef}`
      );

      if (!response.ok) throw new Error("Erro ao buscar Controle");

      const data = await response.json();

      if (lastRequestRef.current !== requestId) return;

      setCtrlAtendimentos(data);
      setMesFechadoCtrl(data.isMonthClosed);

      const totalExt = Number(data?.qtExtraSessions || 0) * Number(terapeuta?.extraFee || 0);
      setTotalExtras(totalExt);

      let salario = 0;
      let totalAtendimentos = 0;
      let totalFaltasComDesconto = 0;
      let totalFaltasSemDesconto = 0;
      let qtdTotalAtendimentos = 0;

      if (Array.isArray(data.sessionControlCalculatedByPosition)) {
        data.sessionControlCalculatedByPosition.forEach((a) => {
          const qtAppointments = Number(a?.qtAppointments) || 0;
          const salary = Number(a?.salary) || 0;
          const absenceDiscount = Number(a?.qtAbsenceDiscount) || 0;
          const absenceNotDiscount = Number(a?.qtAbsenceNotDiscount) || 0;
          
          totalAtendimentos += qtAppointments;
          totalFaltasComDesconto += absenceDiscount;
          totalFaltasSemDesconto += absenceNotDiscount;
          qtdTotalAtendimentos += qtAppointments;
          salario += (qtAppointments - totalFaltasComDesconto)  * salary;
        });
      }

      setTotalAtendimentos(salario);
      setTotalFaltasComDesconto(totalFaltasComDesconto);
      setTotalFaltasSemDesconto(totalFaltasSemDesconto);
      setQtdeTotalAtendimentos(qtdTotalAtendimentos);

      // Agora seta o salário total com segurança, mesmo se não houver posições
      setSalarioMes((Number(salario) || 0) + (Number(totalExt) || 0));

    } catch (error) {
      console.error("Erro ao carregar Controles:", error);
    }
  };




  // Remove the useEffect that loads data on mount
  // useEffect(() => {
  //   fetchCtrlAtendimentos();
  // }, [anoRef, mesRef]);

  // Keep this useEffect to update data when month/year changes after initial load
  useEffect(() => {
    if (sessionControlLoaded) {
      fetchCtrlAtendimentos();
    }
  }, [anoRef, mesRef]);

  const vincularFuncao = async (e) => {
    (e).preventDefault();

    const payload = {
      therapistId: id,
      jobPositionId: formAddFuncao.jobPositionId,
      salary: parseFloat(formAddFuncao.salary.replace('.', '').replace(',', '.')),
    };

    try {
      const response = await authFetch("therapist-job-position", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Erro ao adicionar função");
      }

      // Buscar funções do terapeuta novamente
      const responseFuncoesTerap = await authFetch(`therapist-job-position/therapist/${id}`, {});
      if (!responseFuncoesTerap.ok) {
        throw new Error("Erro ao buscar funções do terapeuta");
      }
      const dataFuncoesTerap = await responseFuncoesTerap.json();
      setFuncoesTerap(dataFuncoesTerap);

      showNotification("success", "Função vinculada com sucesso!");
      setShowFormFuncao(false);

      // Resetando o estado após o sucesso
      setFormAddFuncao({
        therapistId: id,
        jobPositionId: "",
        salary: 0,
      });

    } catch (error) {
      console.error(error);
      showNotification("danger", "Erro ao adicionar função");
    }
  }

  const handleExcluirFuncao = async () => {
    if (!funcaoParaExcluir) return;

    try {
      const response = await authFetch(`therapist-job-position/${funcaoParaExcluir.id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error("Erro ao excluir função");
      }

      // Buscar funções do terapeuta novamente
      const responseFuncoesTerap = await authFetch(`therapist-job-position/therapist/${id}`, {});
      if (!responseFuncoesTerap.ok) {
        throw new Error("Erro ao buscar funções do terapeuta");
      }
      const dataFuncoesTerap = await responseFuncoesTerap.json();
      setFuncoesTerap(dataFuncoesTerap);

      showNotification("success", "Função excluída com sucesso!");
    } catch (error) {
      console.error(error);
      showNotification("danger", "Erro ao excluir função");
    } finally {
      setShowModalExcluirFuncao(false);
      setFuncaoParaExcluir(null);
    }
  };

  const confirmarExclusaoFuncao = (funcao) => {
    setFuncaoParaExcluir(funcao);
    setShowModalExcluirFuncao(true);
  };

  const calcularTotalExtras = (qtdeExtras) => {
    const qt = qtdeExtras ?? ctrlatendimentos?.qtExtraSessions ?? 0;
    const totalExtras = qt * terapeuta.extraFee;
    setTotalExtras(totalExtras);
    setSalarioMes(totalExtras + totalAtendimentos);
  }

  // Função para forçar atualização do calendário da escala
  const forcarAtualizacaoEscala = () => {
    escalaCache.limparTodoCache();
    
    // Forçar re-render do calendário
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.refetchEvents();
    }
  };

  const buscarEventos = (mes, ano) => {
    const key = `${mes}-${ano}`;

    if (pendingFetches.current.has(key)) {
      return pendingFetches.current.get(key);
    }

    const promise = authFetch(`appointment?therapistId=${id}&month=${mes}&year=${ano}`)
      .then(res => {
        if (!res.ok) throw new Error('Erro ao buscar eventos');
        return res.json();
      })
      .then(data => {
        const eventosFormatados = data.map((evento) => ({
          id: evento.id,
          title: evento.title,
          start: evento.startDatetime,
          end: evento.endDatetime,
          color: '#3788d8',
          extendedProps: {
            patientId: evento.patientId,
            therapistId: evento.therapistId,
            planId: evento.planId,
            jobPositionId: evento.jobPositionId,
            note: evento.note,
            appointmentType: evento.appointmentType,
            absenceType: evento.absenceType,
            chargeable: evento.chargeable,
            allowReschedule: evento.allowReschedule,
            therapists: evento.therapists,
            value: evento.value,
            therapist: evento.therapist,
            patient: evento.patient,
            color: evento.therapist?.color,
          },
        }));
        escalaCache.marcarTimestampCache(mes, ano);
        return eventosFormatados;
      })
      .catch(err => {
        showNotification('danger', 'Erro ao carregar os eventos do calendário');
        return [];
      })
      .finally(() => {
        pendingFetches.current.delete(key);
      });

    pendingFetches.current.set(key, promise);
    return promise;
  };

  // Busca Planos do Paciente que foi selecionado
  const buscarPlanos = async () => {
    if (!pacienteSelecionado?.id) return;

    try {
      const res = await authFetch(`patient-plan/patient/${pacienteSelecionado.id}`, {
      });
      if (!res.ok) throw new Error('Erro ao buscar planos');
      const data = await res.json();
      setPlanosPaciente(data);
    } catch (err) {
      showNotification('danger', 'Erro ao carregar planos do paciente');
      setPlanosPaciente([]);
    }
  };

  useEffect(() => {
    buscarPlanos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pacienteSelecionado]);

  // Busca Funções da terapeuta selecionada
  useEffect(() => {
    const buscarFuncoes = async () => {
      if (!terapeutaSelecionado?.id) return;
      try {
        const res = await authFetch(`therapist-job-position/therapist/${terapeutaSelecionado.id}`, {
        });
        if (!res.ok) throw new Error('Erro ao buscar funções');
        const data = await res.json();
        setFuncoesTerapeuta(data);
      } catch (err) {
        showNotification('danger', 'Erro ao buscar funções da terapeuta');
        setFuncoesTerapeuta([]);
      }
    };

    buscarFuncoes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [terapeutaSelecionado]);

  const handleEventClick = async (info) => {
    const event = info.event;

    // Verificar se estamos na aba "Escala" para definir modo read-only
    const escalaTab = document.getElementById('nav-escala-tab');
    const isEscalaActive = escalaTab?.classList.contains('active');
    setIsReadOnlyModal(isEscalaActive || false);

    setOutrasTerapeutas([]);
    setFaturada(0);
    setGeraReposicao(0);
    setReposicao(0);

    setTitulo(event.title);
    setDataInicio(event.startStr.split("T")[0]);
    setHoraInicio(event.startStr.split("T")[1]?.substring(0, 5) || "");
    setDataFim(event.startStr.split("T")[0]);
    setHoraFim(event.endStr?.split("T")[1]?.substring(0, 5) || "");
    setAllDay(event.allDay);

    // Se você tiver campos personalizados no `extendedProps`:
    const { appointmentType, absenceType, chargeable, allowReschedule, patientId, planId, therapistId, jobPositionId, therapists, note, value, therapist, patient } = event.extendedProps;

    setTipoAgendEdit(appointmentType);

    if (absenceType === 1 || absenceType === 2) {
      setFalta(1);
      if (absenceType === 2) {
        setFaturada(1);
      }
    } else {
      setFalta(0);
    }

    if (absenceType === 3) {
      setReposicao(1);
    }

    setConsideraValor(chargeable ? 1 : 0);
    setGeraReposicao(allowReschedule ? 1 : 0);

    if (appointmentType !== 0) {
      // 🔹 Preencher autocomplete e plano do paciente
      // const paciente = await buscarPacientePorId(patientId);
      if (patient) {
        setPacienteSearch(patient.name);
        setPacienteSelecionado(patient);
        // buscarPlanosDoPaciente(paciente.id);
        setPacienteFoiSelecionadoExternamente(true);
      }

      // 🔹 Preencher autocomplete do terapeuta principal e funções
      // const terapeuta = await buscarTerapeutaPorId(therapistId);
      if (therapist) {
        setTerapeutaSearch(therapist.name);
        setTerapeutaSelecionado(therapist);
        setTerapeutaFoiSelecionadoExternamente(true); // ao selecionar, fecha a lista também
      }

    }
    // Preencher campos do form
    setFormEditEvent({
      id: event.id,
      patientId: patientId,
      therapistId: therapistId,
      jobPositionId: jobPositionId,
      planId: planId,
      note: note,
      value: formatarParaMoeda((value ?? 0).toFixed(2).toString()),
      therapists: therapists
    });

    // 🔹 Preencher outras terapeutas (se houver)        
    const terapeutasExtras = await buscarTerapeutasExtrasEventoEdit(event.id);
    if (terapeutasExtras) {
      setOutrasTerapeutas(terapeutasExtras);
    }

    // Abre o modal
    setShowModalEdit(true);
  };

  const [disabledGeraRepo, setDisabledGeraRepo] = useState(false);
  useEffect(() => {
    if (falta === 0 || falta === false) {
      setGeraReposicao(0);
      setDisabledGeraRepo(true); // desativa
    } else {
      setDisabledGeraRepo(false); // ativa
    }
  }, [falta]);

  //Monitora Alteração do Checkbox de Reposição para zerar e desativar os campos Falta, Faturada e Gera Reposição
  const [disabledFalta, setDisabledFalta] = useState(false);
  const [disabledFaturada, setDisabledFaturada] = useState(false);
  useEffect(() => {
    if (reposicao === 1 || reposicao === true) {
      setFalta(0);
      setFaturada(0);
      setDisabledFalta(true);
      setDisabledFaturada(true);
    } else {
      setDisabledFalta(false);
      setDisabledFaturada(false);
    }
  }, [reposicao]);

  // Monitora quando a aba Escala se torna ativa e força atualização automática
  useEffect(() => {
    const limparCache = escalaCache.limparTodoCache;

    const handleTabChange = () => {
      setTimeout(() => {
        const escalaTab = document.getElementById('nav-escala-tab');
        const escalaContent = document.getElementById('nav-escala');
        if (escalaTab?.classList.contains('active') && escalaContent?.classList.contains('show')) {
          limparCache();
          calendarRef.current?.getApi().refetchEvents();
        }
      }, 100);
    };

    document.addEventListener('shown.bs.tab', handleTabChange);
    return () => document.removeEventListener('shown.bs.tab', handleTabChange);
  }, [escalaCache.limparTodoCache]);

  if (loading) return <PageLoader />;
  if (error) return <p>Erro: {error}</p>;

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body p-3">
            <div className="row col-md-12">
              <div className="col-auto">
                <div className="avatar rounded-circle avatar-xxl position-relative">
                  <img
                    src={preview || require('../../assets/img/perfilvazio.png')}
                    className='personal-avatar'
                    alt='imagem-perfil'
                    name="imagem-perfil"
                    id='imagem-perfil'
                  />
                </div>
              </div>
              <div className="col-md-8">
                <div className="col-md-8">
                  <h2>{terapeuta.name}</h2>
                </div>
                <div className="col-md-8">
                  <Link to={'/Terapeutas'} className="btn btn-info btn-sm">Voltar</Link>
                  <Link to={`/Terapeutas/Editar/${terapeuta.id}`} className="btn btn-primary btn-sm mx-1">Editar</Link>
                  {terapeuta.userId == null && (
                    <button className="btn btn-info btn-sm" onClick={BotaoGerarUsuario}>
                      Criar Usuário
                    </button>
                  )}
                  {terapeuta.userId != null && userAPIData.id === terapeuta.userId && (
                    <button className="btn btn-warning btn-sm" onClick={BotaoGerarUsuario}>
                      Editar Usuário
                    </button>
                  )}
                  {terapeuta.userId != null && userAPIData.id !== terapeuta.userId && (
                    <button className="btn btn-info btn-sm mx-1" onClick={BotaoGerarUsuario}>
                      Ver Usuário
                    </button>
                  )}
                </div>
                {sorrisoAutin() && (
                  <img src={require("../../assets/img/sorrisoAutin.png")} style={{ height: "40px" }} alt='sorrisoAutin' />
                )}
              </div>
              {userAPIData.userRoleId === 1 && (
                <div className="col-md-2">
                  <button
                    className="nav-link btn btn-link p-0"
                    onClick={() => setShowConfirmDeleteTerapeuta(true)}
                  >
                    <div className="icon icon-shape icon-sm shadow border-radius-md bg-danger text-center me-2 d-flex align-items-center justify-content-center">
                      <i className="fa-solid fa-trash-can text-white"></i>
                    </div>
                  </button>
                </div>
              )}
            </div>
            <br />
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <a className={`nav-link ${!location.state?.abrirEscala ? 'active' : ''}`} id="nav-dados-tab" data-bs-toggle="tab" data-bs-target="#nav-dados" role="tab" aria-controls="nav-dados" aria-selected="true">Dados</a>
                <a className={`nav-link ${location.state?.abrirEscala ? 'active' : ''}`} id="nav-escala-tab" href="#nav-escala" data-bs-toggle="tab" data-bs-target="#nav-escala" role="tab" aria-controls="nav-escala" aria-selected="false" onClick={handleTabClick}>Escala</a>
                <a className="nav-link" id="nav-casosger-tab" data-bs-toggle="tab" data-bs-target="#nav-casosger" role="tab" aria-controls="nav-casosger" aria-selected="false" onClick={handleCasosGerenciadosClick}>Casos Gerenciados</a>
                <a className="nav-link" id="nav-introduction-tab" data-bs-toggle="tab" data-bs-target="#nav-introduction" role="tab" aria-controls="nav-introduction" aria-selected="false">Apresentação</a>
                {(userAPIData.userRoleId === 1 || (userAPIData.userRoleId === 4 && userAPIData.id === terapeuta.userId)) && terapeuta.therapistLevel !== 2 && (
                  <>
                    <a className="nav-link" id="nav-funcoes-tab" data-bs-toggle="tab" data-bs-target="#nav-funcoes" role="tab" aria-controls="nav-funcoes" aria-selected="false" onClick={handleFuncoesClick}>Funções</a>
                    <a className="nav-link" id="nav-ctrlatend-tab" data-bs-toggle="tab" data-bs-target="#nav-ctrlatend" role="tab" aria-controls="nav-ctrlatend" aria-selected="false" onClick={handleControleAtendimentosClick}>Controle de Atendimentos</a>
                  </>
                )}
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <section className={`tab-pane fade ${!location.state?.abrirEscala ? 'show active' : ''}`} id="nav-dados" role="tabpanel" aria-labelledby="nav-dados-tab">
                <div className="col-md-12 container row">
                  <div className="col-md-4">
                    <label htmlFor="nickname">Apelido</label>
                    <input type="text" name="nickname" id="nickname" className="form-control form-control-sm" readOnly value={terapeuta.nickname} />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="therapistLevel">Nível</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={niveisTerapeuta[terapeuta.therapistLevel] || ''}
                      disabled
                      readOnly
                      name="therapistLevel"
                      id="therapistLevel"
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="color">Cor</label>
                    <span className="span-color"
                      style={{
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        backgroundColor: `${terapeuta.color}`,
                        display: "block",
                        marginleft: "5px",
                        margintop: "4px"
                      }}
                    ></span>
                    <input
                      type="color"
                      className="form-control form-control-sm input-color"
                      value={terapeuta.color}
                      disabled
                      id="color"
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        width: "3em",
                        borderRadius: "50%",
                        display: "none"
                      }}
                    />
                  </div>
                  <div className="col-md-4">

                  </div>
                  <div className="col-md-2">
                    <label>Data de Nascimento</label>
                    <span id="color_front"></span>
                    <DateDisplay
                      name="birthdate"
                      id="birthdate"
                      className="form-control form-control-sm"
                      value={terapeuta.birthdate}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Idade</label>
                    <input type="text" className="form-control form-control-sm" readOnly value={idadeFormatada} />
                  </div>
                  <div className="col-md-2">
                    <label>Data de Início Autin</label>
                    <DateDisplay
                      name="hiringDate"
                      id="hiringDate"
                      className="form-control form-control-sm"
                      value={terapeuta.hiringDate}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Tempo de Autin</label>
                    <input type="text" name="tempoAutin" id="tempoAutin" className="form-control form-control-sm" readOnly value={tempoAutin} />
                  </div>
                  <div className="col-md-8">
                    <label>Valores</label>
                    <input type="text" name="valores" id="valores" className="form-control form-control-sm" readOnly value={terapeuta.principles || ""} />
                  </div>
                  <div className="col-md-8">
                    <br />
                    <div className="form-check form-switch">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="disabled"
                        checked={terapeuta.disabled}
                        readOnly
                      />
                      <label className="form-check-label">Desativado</label>
                    </div>
                  </div>
                </div>
              </section>
              <section className={`tab-pane fade ${location.state?.abrirEscala ? 'show active' : ''}`} id="nav-escala" role="tabpanel" aria-labelledby="nav-escala-tab">
                <div className="card card-calendar">
                  <div className="card-body p-3">
                    {/* Botão "Atualizar Escala" removido conforme solicitado */}
                    <FullCalendar
                      ref={calendarRef}
                      plugins={[dayGridPlugin, TimeGridPlugin, bootstrap5Plugin, listPlugin]}
                      headerToolbar={{
                        start: 'prev,next today',
                        center: 'title',
                        end: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
                      }}
                      locales={[ptBrLocale]}  // passa a lista de locales suportados
                      locale="pt-br"    // define o locale ativo
                      themeSystem='bootstrap5'
                      timeZone='America/Sao_Paulo'
                      buttonIcons={true} // show the prev/next text
                      weekNumbers={false}
                      navLinks={true} // can click day/week names to navigate views
                      editable={false}
                      selectable={false}
                      dayMaxEvents={true} // allow "more" link when too many events
                      slotDuration='00:30:00'
                      initialView={ViewAtual}
                      initialDate={DataAtual}
                      hiddenDays={[0, 6]}
                      businessHours={{
                        //segunda a sexta, das 8h às 18h
                        daysOfWeek: [1, 2, 3, 4, 5],
                        startTime: '08:00',
                        endTime: '18:00',
                      }}
                      events={async (fetchInfo, successCallback, failureCallback) => {
                        try {
                          const endDate = new Date(fetchInfo.end);
                          // Cursor sempre no dia 1 do mês para evitar overflow do setMonth
                          // (ex.: 31/mai + 1 mês "pularia" junho, pois junho tem 30 dias)
                          const startDate = new Date(
                            fetchInfo.start.getFullYear(),
                            fetchInfo.start.getMonth(),
                            1
                          );
                          const eventosTotais = [];

                          while (startDate < endDate) {
                            const mes = startDate.getMonth() + 1;
                            const ano = startDate.getFullYear();

                            let eventosMes = escalaCache.getEventosFromCache(mes, ano);

                            if (!eventosMes) {
                              const fetchedEventos = await buscarEventos(mes, ano);
                              eventosMes = fetchedEventos.map(evento => {
                                const tipo = evento.extendedProps?.appointmentType;
                                let cor = evento.extendedProps?.color || '#3788d8';
                                if (tipo === 2) cor = '#000';
                                else if (tipo === 0) cor = '#eb6737';
                                return { ...evento, color: cor };
                              });
                              escalaCache.salvarEventosNoCache(mes, ano, eventosMes);
                            }

                            eventosTotais.push(...eventosMes);
                            // startDate está sempre no dia 1, então avançar o mês é seguro
                            startDate.setMonth(startDate.getMonth() + 1);
                          }

                          successCallback(eventosTotais);
                        } catch (err) {
                          console.error('Erro ao carregar eventos:', err);
                          failureCallback(err);
                        }
                      }}
                      eventClick={handleEventClick}
                    />
                  </div>
                </div>
              </section>
              <section className="tab-pane fade" id="nav-casosger" role="tabpanel" aria-labelledby="nav-casosger-tab">
                <div className="col-md-12 container row">
                  <label>Casos Gerenciados</label>
                  {pacientesGer.map((a) => {
                    const nomePaciente = a.name?.split(" ")[0]; // campo 'name' do endpoint patient

                    return (
                      <div className="col-md-3" key={a.id}>
                        <Link to={`/Pacientes/Perfil/${a.id}`} className="text-decoration-none">
                          <div className="d-flex px-2 py-1 align-items-center">
                            <div>
                              {a.imageLoading ? (
                                <div className="spinner-border text-primary" role="status" style={{ width: "40px", height: "40px" }}>
                                  <span className="visually-hidden">Carregando...</span>
                                </div>
                              ) : (
                                <img
                                  src={a.imageUrl || require('../../assets/img/perfilvazio.png')}
                                  alt={nomePaciente}
                                  className="avatar avatar-sm me-3"
                                  style={{ borderRadius: "1.75em", width: "40px", height: "40px" }}
                                />
                              )}
                            </div>
                            <div className="d-flex flex-column justify-content-center">
                              <p className="mb-0 text-xs text-dark">{nomePaciente}</p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </section>
              <section className="tab-pane fade" id="nav-introduction" role="tabpanel" aria-labelledby="nav-introduction-tab">
                <div className="col-md-12 container">
                  <label>Apresentação</label>
                  <textarea name="introduction" id="introduction" value={terapeuta.introduction} className="form-control" readOnly style={{ minHeight: "20em" }}></textarea>
                </div>
              </section>
              {(userAPIData.userRoleId === 1 || (userAPIData.userRoleId === 4 && userAPIData.id === terapeuta.userId)) && terapeuta.therapistLevel !== 2 && (
                <section className="tab-pane fade" id="nav-funcoes" role="tabpanel" aria-labelledby="nav-funcoes-tab">
                  <div className="col-md-12 container">
                    {funcoesTerap.map((funcao) => (
                      <div className="row" key={funcao.id}>
                        <div className="col-md-3">
                          <label>Descrição</label>
                          <input
                            type="text"
                            name="descricao"
                            className="form-control form-control-sm"
                            readOnly
                            value={funcao.jobPosition.name}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>Valor</label>
                          <input
                            type="text"
                            name="salary"
                            className="form-control form-control-sm"
                            readOnly
                            value={funcao.salary}
                          />
                        </div>
                        <div className="col-md-2" style={{ marginTop: "1.5em" }}>
                          {userAPIData.userRoleId <= 2 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => confirmarExclusaoFuncao(funcao)}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    ))}

                    <div>
                      {showFormFuncao && (
                        <form onSubmit={vincularFuncao}>
                          <div className="py-2" id="AddFuncao">
                            <div className="row">
                              <div className="col-md-3">
                                <label>Função</label>
                                <select
                                  name="jobPositionId"
                                  id="jobPositionId"
                                  className="form-control form-control-sm"
                                  value={formAddFuncao.jobPositionId || ''}
                                  onChange={handleInputChangeFunc}
                                >
                                  <option value="" disabled>Selecione uma função</option>
                                  {funcoes.map((f) => (
                                    <option key={f.id} value={f.id}>{f.name}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-md-3">
                                <label>Valor</label>
                                <input type="text" name="salary" id="salary" className="form-control form-control-sm" onChange={handleInputChangeFunc} value={formAddFuncao.salary || ''} />
                              </div>
                              <div className="col-md-5" style={{ marginTop: "1.9em" }}>
                                <button onClick={CancelaAddFuncao} className="btn btn-info btn-sm" type="button">
                                  Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary btn-sm mx-1">Vincular</button>
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                      {userAPIData.userRoleId <= 2 && (
                        <button onClick={AddFuncao} className="btn btn-primary btn-sm mt-2">
                          Adicionar Função
                        </button>
                      )}
                    </div>
                  </div>
                </section>
              )}
              {(userAPIData.userRoleId === 1 || (userAPIData.userRoleId === 4 && userAPIData.id === terapeuta.userId)) && terapeuta.therapistLevel !== 2 && (
                <section className="tab-pane fade" id="nav-ctrlatend" role="tabpanel" aria-labelledby="nav-ctrlatend-tab">

                  <div>
                    <div className="col-md-12 container row">
                      <div className="col-md-12">
                        <input type="hidden" name="idterapeuta" value={terapeuta?.id || ''} />

                        {/* Filtros Ano/Mês */}
                        <div className="col-md-12 row by-2 py-3">
                          <div className="col-md-1"><label>Ano Referência</label></div>
                          <div className="col-md-2">
                            <div className="input-group mb-3">
                              <input
                                type="text"
                                name="anopagamento"
                                id="anopagamento"
                                className="form-control form-control-sm"
                                value={anoRef}
                                onChange={handleAnoRefChange}
                                maxLength={4}
                                style={{ marginLeft: "1em" }}
                              />
                              <span className="input-group-text"><i className="fa-solid fa-calendar-plus"></i></span>
                            </div>
                          </div>

                          <div className="col-md-1"><label>Mês Referência</label></div>
                          <div className="col-md-2">
                            <div className="input-group mb-3">
                              <select
                                name="mespagamento"
                                id="mespagamento"
                                className="form-control form-control-sm"
                                value={mesRef}
                                onChange={handleMesRefChange}
                                style={{ marginLeft: "1em" }}
                              // disabled={loadingCtrlAtendimentos}
                              >
                                {meses.map((mes) => (
                                  <option key={mes} value={mes}>{mes}</option>
                                ))}
                              </select>
                              <span className="input-group-text"><i className="fa-solid fa-calendar-plus"></i></span>
                            </div>
                          </div>

                          <div className="col-md-2">
                            {/* <button type="submit" form="form-filtrar" className="btn btn-sm btn-info">Filtrar</button> */}
                          </div>

                          <div className="col-md-4"></div>
                        </div>

                        {/* Totais */}
                        <div className="col-md-12 row">
                          <div className="col-md-3">
                            <label>Total Atendimentos Mês</label>
                            <div className="input-group">
                              <input type="text" readOnly className="form-control form-control-sm"
                                style={{ marginLeft: "1em" }}
                                value={
                                  ctrlatendimentos
                                    ? (mesFechadoCtrl === true
                                      ? formatarValor(ctrlatendimentos?.totalValue ?? 0)
                                      : formatarValor(totalAtendimentos))
                                    : formatarValor(0)
                                }
                              />
                              <span className="input-group-text"><i className="fa-solid fa-brazilian-real-sign"></i></span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <label>Total Extras no Mês</label>
                            <div className="input-group">
                              <input type="text" readOnly className="form-control form-control-sm" style={{ marginLeft: "1em" }}
                                value={
                                  ctrlatendimentos
                                    ? (mesFechadoCtrl === true
                                      ? formatarValor(ctrlatendimentos.totalExtraValue ?? 0)
                                      : formatarValor(totalExtras ?? 0))
                                    : formatarValor(0)
                                }

                              />
                              <span className="input-group-text"><i className="fa-solid fa-brazilian-real-sign"></i></span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <label>Salário do Mês</label>
                            <div className="input-group">
                              <input type="text" readOnly className="form-control form-control-sm" style={{ marginLeft: "1em" }}
                                value={
                                  ctrlatendimentos
                                    ? (mesFechadoCtrl === true
                                      ? formatarValor(ctrlatendimentos?.monthlySalary ?? 0)
                                      : formatarValor((salarioMes) ?? 0))
                                    : formatarValor(0)
                                }
                              />
                              <span className="input-group-text"><i className="fa-solid fa-brazilian-real-sign"></i></span>
                            </div>
                          </div>

                          {/* Botões de ação */}
                          <div className="col-md-12 container row mt-2">
                            {ctrlatendimentos &&
                              mesFechadoCtrl === true ? (
                              <>
                                <div className="col-md-8"></div>
                                {userAPIData.userRoleId <= 2 && (
                                  <div className="col-md-2">
                                    <button
                                      className="btn btn-danger btn-sm"
                                      style={{ marginLeft: '1em' }}
                                      onClick={reabrirMesFechado} // função que você define
                                    >
                                      Reabrir
                                    </button>
                                  </div>
                                )}
                              </>
                            ) : (
                              <>
                                <div className="col-md-6"></div>
                                <div className="col-md-2">
                                  <button className="btn btn-info btn-sm" onClick={salvarMes}>
                                    Salvar Mês
                                  </button>
                                </div>
                                <div className="col-md-2">
                                  <button className="btn btn-primary btn-sm" onClick={setarMesFechado}>
                                    Fechar Mês
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        <hr />
                      </div>

                      {funcoes && (
                        <>
                          {ctrlatendimentos && (
                            <>
                              {ctrlatendimentos?.sessionValue && mesFechadoCtrl === true ? null : (
                                <>
                                  {ctrlatendimentos?.sessionControlCalculatedByPosition?.length > 0 ? (
                                    ctrlatendimentos.sessionControlCalculatedByPosition.map((f, index) => (
                                      <div className="col-md-12 row" key={index}>
                                        <h6>{f?.jobPositionName}</h6>

                                        <div className="col-md-3">
                                          <label>Quantidade de Atendimentos</label>
                                          <div className="form-group">
                                            <div className="col-md-12 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm numero"
                                                value={f.qtAppointments}
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-user-clock"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-3">
                                          <label>Valor</label>
                                          <div className="form-group">
                                            <div className="col-md-4 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm dinheiro"
                                                value={Number(f.salary).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-brazilian-real-sign"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-2">
                                          <label>Faltas Sem Desconto</label>
                                          <div className="form-group">
                                            <div className="col-md-4 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm"
                                                value={f.qtAbsenceNotDiscount}
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-user-xmark"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-2">
                                          <label>Faltas Com Desconto</label>
                                          <div className="form-group">
                                            <div className="col-md-4 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm"
                                                value={f.qtAbsenceDiscount}
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-user-xmark"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <hr />
                                      </div>
                                    ))
                                  ) : (
                                    funcoes.map((f, index) => (
                                      <div className="col-md-12 row" key={index}>
                                        <h6>{f?.fc?.name}</h6>

                                        <div className="col-md-3">
                                          <label>Quantidade de Atendimentos</label>
                                          <div className="form-group">
                                            <div className="col-md-12 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm numero"
                                                value={
                                                  (
                                                    ctrlatendimentos?.qtde_atend && ctrlatendimentos?.mes_fechado === 1)
                                                    ? ctrlatendimentos.qtde_atend
                                                    : f.quantidade + f.quantidadeSub || 0
                                                }
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-user-clock"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-3">
                                          <label>Valor</label>
                                          <div className="form-group">
                                            <div className="col-md-4 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm dinheiro"
                                                value={
                                                  ctrlatendimentos?.valor_atendimento && ctrlatendimentos?.mes_fechado === 1
                                                    ? Number(ctrlatendimentos.valor_atendimento).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                                                    : Number(f.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                                                }
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-brazilian-real-sign"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-2">
                                          <label>Faltas Sem Desconto</label>
                                          <div className="form-group">
                                            <div className="col-md-4 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm"
                                                value={0}
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-user-xmark"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-2">
                                          <label>Faltas Com Desconto</label>
                                          <div className="form-group">
                                            <div className="col-md-4 input-group">
                                              <input
                                                type="text"
                                                readOnly
                                                className="form-control form-control-sm"
                                                value={0}
                                                style={{ marginLeft: '1em' }}
                                              />
                                              <span className="input-group-text"><i className="fa-solid fa-user-xmark"></i></span>
                                            </div>
                                          </div>
                                        </div>

                                        <hr />
                                      </div>
                                    ))
                                  )}
                                </>
                              )}                          </>
                          )}
                        </>
                      )}

                      {!funcoes?.length && (
                        <div className="col-md-12">
                          <p>Adicione alguma função para esta terapeuta para controlar os atendimentos</p>
                          <hr />
                        </div>
                      )}

                      {/* Extras */}
                      <div className="col-md-12 row">
                        <h6>Extras</h6>

                        <div className="col-md-3">
                          <label>Quantidade de Extras</label>
                          <div className="form-group">
                            <div className="col-md-12 input-group">
                              <input
                                type="number"
                                id="qtde_extras"
                                className="form-control form-control-sm numero"
                                style={{ marginLeft: '1em' }}
                                value={ctrlatendimentos?.qtExtraSessions ?? 0}
                                onChange={e => {
                                  setCtrlAtendimentos(prev => ({
                                    ...prev,
                                    qtExtraSessions: e.target.value
                                  }));
                                  calcularTotalExtras(e.target.value);
                                }}
                                onBlur={(e) => calcularTotalExtras(e.target.value)}
                              />
                              <span className="input-group-text"><i className="fa-solid fa-business-time"></i></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <label>Valor Hora dos Extras</label>
                          <div className="form-group">
                            <div className="col-md-4 input-group">
                              <input
                                type="text"
                                readOnly
                                className="form-control form-control-sm dinheiro"
                                style={{ marginLeft: '1em' }}
                                value={
                                  ctrlatendimentos?.sessionExtraValue && mesFechadoCtrl === true
                                    ? Number(terapeuta.extraFee).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                                    : Number(terapeuta.extraFee).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                                }
                              />
                              <span className="input-group-text"><i className="fa-solid fa-brazilian-real-sign"></i></span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 mb-2">
                        <label>Descrição dos Extras</label>
                        <div className="col-md-12">
                          <textarea
                            id="descr_extras"
                            className="form-control form-control-sm"
                            maxLength={5000}
                            value={ctrlatendimentos?.description ?? ''}
                            onChange={e => setCtrlAtendimentos(prev => ({ ...prev, description: e.target.value }))}
                            rows={6}
                          />
                          <span id="caracteres-textarea-extras" />
                        </div>
                      </div>

                      <hr />
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      </div>


      {/* <!----------------- MODAL VISUALIZAR--------------------------------> */}
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered>
        <div className="modal-content">
          <div className="modal-header text-center" style={{ display: "block", paddingBottom: "0px" }}>
            <h5 className="modal-title">{isReadOnlyModal ? "Visualizar Evento" : "Evento"}</h5>
            <button type="button" className="btn-close" onClick={() => setShowModalEdit(false)} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="col-md-12 container">
              <div className="row">
                <label>Título</label>
                <input
                  type="text"
                  id="titleEdit"
                  name="title"
                  className="form-control form-control-sm"
                  value={titulo}
                  onChange={(e) => setTitulo(e.target.value)}
                  readOnly
                />

                <div className="row">
                  <div className="col-md-3">
                    <label>Data Início</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text"><i className="fa-solid fa-calendar-days"></i></span>
                      <input
                        type="date"
                        id="startAdd"
                        name="startDate"
                        className="form-control form-control-sm"
                        value={dataInicio}
                        onChange={handleDataInicioChange}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <label>Hora Início</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text"><i className="fa-solid fa-clock"></i></span>
                      <select
                        className="form-control form-control-sm"
                        value={horaInicio}
                        onChange={handleHoraInicioChange}
                        disabled={allDay}
                        readOnly
                      >
                        {horarios
                          .filter(h => h >= "00:00" && h <= "23:00")
                          .map((hora) => (
                            <option key={hora} value={hora}>{hora}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  {tipoAgendEdit !== 1 && (
                    <div className="col-md-4">

                      <div>
                        <label>&nbsp;</label>
                        <div className="form-check form-switch mt-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="allDay"
                            id="allDay"
                            checked={allDay}
                            onChange={handleAllDayChange}
                            readOnly
                          />
                          <label className="form-check-label" htmlFor="allDay">Dia Todo</label>
                        </div>
                      </div>

                    </div>
                  )
                  }
                  {tipoAgendEdit === 1 && (
                    <div className="col-md-4">
                      <label>&nbsp;</label>
                      <div className="form-check form-switch mt-2">
                        <input className="form-check-input" type="checkbox" name="reposicao" id="reposicao" checked={reposicao === 1} disabled />
                        <label className="form-check-label" htmlFor="reposicao">Reposição</label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-3">
                    <label>Tipo</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text"><i className="fa-solid fa-circle-info"></i></span>
                      <select className='form-control form-control-sm' /*onChange={alteraTipo}*/ value={tipoAgendEdit} disabled>
                        {tiposAgendamento.map(t => (
                          <option key={t.id} value={t.id}>
                            {t.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <label>Data Fim</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text"><i className="fa-solid fa-calendar-days"></i></span>
                      <input
                        type="date"
                        id="endAdd"
                        name="endDate"
                        className="form-control form-control-sm"
                        value={dataFim}
                        onChange={handleDataFimChange}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <label>Hora Fim</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text"><i className="fa-solid fa-clock"></i></span>
                      <select
                        className="form-control form-control-sm"
                        value={horaFim}
                        disabled={true}
                      >
                        {horarios
                          .filter(h => h >= "01:00" && h <= "23:59")
                          .map((hora) => (
                            <option key={hora} value={hora}>{hora}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  {tipoAgendEdit === 1 ? (
                    <>
                      <div className="col-md-2">
                        <label>&nbsp;</label>
                        <div className="form-check form-switch mt-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="falta"
                            id="falta"
                            value={falta}
                            checked={falta === 1}
                            disabled
                          />
                          <label className="form-check-label" htmlFor="falta">Falta</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label>&nbsp;</label>
                        <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" name="faturada" id="faturada" checked={faturada === 1}
                            disabled />
                          <label className="form-check-label" htmlFor="faturada">Faturada</label>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <label>&nbsp;</label>
                        <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" name="geraRepo" id="geraRepo"
                            checked={geraReposicao === 1} disabled
                          />
                          <label className="form-check-label" htmlFor="geraRepo">Gera Reposição</label>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className='col-md-7'></div>
                  )
                  }
                </div>
                <hr />
                {/* Pacientes */}
                {tipoAgendEdit === 1 && (
                  <div className="row" id="TipoSessao">
                    <div className="col-md-6">
                      <label>Paciente</label>
                      <div className="input-group texto mb-3">
                        <span className="input-group-text">
                          <i className="fa-solid fa-child-reaching"></i>
                        </span>
                        <div className="flex-grow-1">
                          <CustomAutoComplete
                            placeholder="Digite o nome do paciente"
                            value={pacienteSearch}
                            setValue={setPacienteSearch}
                            onSelect={(item) => {
                              setFormEditEvent((prev) => ({
                                ...prev,
                                patientId: item.id,
                              }));
                              setPacienteSelecionado(item);
                              setPacienteFoiSelecionadoExternamente(true); // ao selecionar, fecha a lista também
                            }}
                            externalUserSelected={pacienteFoiSelecionadoExternamente}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div id="div-planos-add" style={{ display: pacienteSelecionado ? "block" : "none" }}>
                        <label>Plano</label>
                        <select
                          name="planId"
                          id="planoAdd"
                          className="form-control form-control-sm"
                          value={formEditEvent.planId || ''}
                          readOnly
                        >
                          {planosPaciente.map((plano) => (
                            <option key={plano.id} value={plano.id}>
                              {plano.plan.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {/* Tipo Avulso */}
                {tipoAgendEdit === 2 && (
                  <div className="row" id="TipoReavaliacao">
                    <div className="col-md-6">
                      <label>Paciente</label>
                      <div className="flex-grow-1">
                        <CustomAutoComplete
                          placeholder="Digite o nome do paciente"
                          value={pacienteSearch}
                          setValue={setPacienteSearch}
                          onSelect={(item) => {
                            setFormEditEvent((prev) => ({
                              ...prev,
                              patientId: item.id,
                            }));
                            setPacienteSelecionado(item);
                            setPacienteFoiSelecionadoExternamente(true); // ao selecionar, fecha a lista também
                          }}
                          externalUserSelected={pacienteFoiSelecionadoExternamente}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label>Valor</label>
                      <input type="text" className="form-control form-control-sm" id="valorEdit" name='value' value={formEditEvent.value} readOnly />
                    </div>
                    <div className="col-md-3">
                      <label>Considerar Valor?</label>
                      <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" name="consideraValor" id="consideraValorEdit" checked={consideraValor === 1} disabled />
                      </div>
                    </div>
                  </div>
                )}

                {/* Terapeuta Principal */}
                {tipoAgendEdit !== 0 && (
                  <div className="col-md-6">
                    <label>Terapeuta</label>
                    <div className="input-group texto mb-3">
                      <span className="input-group-text"><i className="fa-solid fa-people-group"></i></span>
                      <div className="flex-grow-1">
                        <CustomAutoComplete
                          placeholder="Digite o nome do terapeuta"
                          value={terapeutaSearch}
                          setValue={setTerapeutaSearch}
                          onSelect={(item) => {
                            setFormEditEvent((prev) => ({ ...prev, therapistId: item.id }));
                            setTerapeutaSelecionado(item);
                            setTerapeutaFoiSelecionadoExternamente(true); // 👈 Marca selecionado manualmente também
                          }}
                          externalUserSelected={terapeutaFoiSelecionadoExternamente}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Funções da Terapeuta */}
                {tipoAgendEdit !== 0 && (
                  <>
                    {terapeutaSelecionado && funcoesTerapeuta.length > 0 && (
                      <div className="col-md-6">
                        <label>Função</label>
                        <select
                          name="funcaoId"
                          className="form-control form-control-sm"
                          value={formEditEvent.jobPositionId || ''}
                          onChange={(e) => setFormEditEvent((prev) => ({ ...prev, jobPositionId: parseInt(e.target.value) }))}
                          readOnly
                        >
                          {funcoesTerapeuta.map((func) => (
                            <option key={func.id} value={func.jobPositionId}>
                              {func.jobPosition?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </>
                )}


                {tipoAgendEdit !== 0 && (
                  <>
                    {terapeutaSelecionado && terapeutaSearch.trim().length > 0 && (
                      <>
                        <div className="col-md-12 mb-2">
                          <label>Outras Terapeutas</label>
                        </div>

                        {showModalEdit && outrasTerapeutas.map((t, index) => {
                          const key = `outra-terapeuta-${t.id}-${index}`;
                          return (
                            <div className="col-md-12 row mb-2" key={key}>
                              {t.isNova ? (
                                <div className="row w-100">
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={t.name}
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <select
                                      className="form-control"
                                      value={t.selectedFuncaoId}
                                      onChange={(e) => {
                                        const novaFuncaoId = parseInt(e.target.value);
                                        setOutrasTerapeutas((prev) => {
                                          const novo = [...prev];
                                          novo[index].selectedFuncaoId = novaFuncaoId;
                                          return novo;
                                        });
                                      }}
                                    >
                                      {t.funcoes.map((f) => (
                                        <option key={f.id} value={f.id}>{f.name}</option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              ) : (
                                <div className="row w-100">
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={t.therapistName}
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={t.jobPositionName}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </>
                    )}
                  </>
                )}
                <div className="col-md-12">
                  <label>Descrição</label>
                  <textarea id="observacao" name="note" className="form-control form-control-sm"
                    onChange={(e) => setFormEditEvent((prev) => ({ ...prev, note: e.target.value }))}
                    value={formEditEvent.note}
                    readOnly
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer row container" style={{ borderTop: 0 }}>
                <div className="row">
                  <div className={isReadOnlyModal ? "col-md-12" : "col-md-10"}></div>
                  <div className="col-md-2">
                    <button type="button" className="btn btn-info" onClick={() => setShowModalEdit(false)}>Fechar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </Modal >

      {showModalExcluirFuncao && (
        <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmar Exclusão</h5>
                <button type="button" className="btn-close" onClick={() => setShowModalExcluirFuncao(false)} />
              </div>
              <div className="modal-body">
                <p>Deseja realmente excluir a função <strong>{funcaoParaExcluir?.jobPosition?.name}</strong>?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModalExcluirFuncao(false)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-danger" onClick={handleExcluirFuncao}>
                  Excluir
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showConfirmDeleteTerapeuta && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmar Exclusão</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirmDeleteTerapeuta(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Tem certeza que deseja excluir este terapeuta?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={() => setShowConfirmDeleteTerapeuta(false)}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDeleteTerapeuta}
                >
                  Excluir
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PerfilTerapeuta